import { AjaxFormModal, AjaxFormContent } from 'sma.common/components/modals';


$(function() {
	$('.ajax-modal').click(function(e) {
        e.preventDefault();
        let $modalButton = $(this);
        let modalUrl = $modalButton.data('url') || $modalButton.attr('href');
        let size = $modalButton.data('size') || 'md';
		let modal = new AjaxFormModal({
			size: size,
			destroyOnClose: true
		});

		modal.addToStack(
			'modal',
			new AjaxFormContent(
				modalUrl,
				{onLoad: () => { modal.show(); }}
			)
		);
    });
});
